<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Клиенты</h2>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Заголовок</th>
                            <th>E-mail</th>
                            <th>Телфон</th>
                            <th>Компания</th>
                            <th>Роль</th>
                            <th>Опции</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in users">
                            <td>{{ item.id }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.email}}</td>
                            <td>{{ item.phone}}</td>
                            <td>{{ item.company}}</td>
                            <td>{{ item.role }}</td>
                            <td>
                                <button @click="beManager(item.id)" class="btn btn-success" v-if="!item.manager_id">Стать менеджером</button>
                                <router-link tag="button" class="btn btn-primary" v-if="item.manager_id" :to="'/managers/users/edit/' + item.id">Изменить</router-link>
                                <router-link tag="button" class="btn btn-primary" v-if="item.manager_id" :to="{name: 'changePassword', params: {id: item.id}}">Изменить пароль</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'message'
        ],
        data() {
            return {
                users: [],
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true
            this.axios
                .get(this.axios.defaults.baseURL + 'manager/users')
                .then(response => {
                    this.users = response.data.users;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })
        },

        methods:{
            beManager(id){
                this.axios
                    .put(this.axios.defaults.baseURL + 'manager/users/attach-role/' + id)
                    .then(response => {
                        console.log(response.data.message)
                        if (response.data.message === 'success'){
                            this.users.find(user => user.id === id).manager_id = 'xxx';
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            update(id){
                this.axios
                    .put(this.axios.defaults.baseURL + 'manager/users/' + id)
                    .then(response => {
                        console.log(response.data)
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/manager/users/Index.vue